<script>
import BaseStream from "@homepage/components/pageStyles/BaseStream";
import ResultDisplay from "@homepage/components/CaribbeanPickComplexResultDisplay.vue";
import {generateImageMapFor} from "@homepage/helpers/image";

export default {
	name: "Stream.vue",
	extends: BaseStream,
	components: {
		ResultDisplay
	},
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
		};
	},
}
</script>

<template>
	<div>
		<winning-numbers-sidebar :open.sync="sidebarOpen" :results="externalLotteriesResults"></winning-numbers-sidebar>
		<v-btn id="external-results-btn" @click="sidebarOpen = !sidebarOpen" style="z-index: 4">
			Winning Numbers
		</v-btn>
		<v-row justify="center">
			<v-col cols="auto">
				<v-img contain height="200" :src="require('@/assets/img/caribbeanPick/logo.png')"></v-img>
			</v-col>
			<v-col cols="auto" align-self="center">
				<v-btn id="see-it-live-btn" class="d-flex" @click="scrollToStream">
					See it live
				</v-btn>
			</v-col>
			<v-col cols="auto">
				<v-img contain height="200" :src="require('@/assets/img/caribbeanPick/logo.png')"></v-img>
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col
				lg="4"
				sm="6"
				cols="12"
				v-for="result in results"
				:key="`${result.date}-${result.sortition.id}`">
				<v-card>
					<result-display class="result-card" :result="result">
						<template #name="{sortition}">
							<h2>
								{{ sortition.name }}
							</h2>
						</template>
					</result-display>
				</v-card>
			</v-col>
		</v-row>

		<v-responsive :aspect-ratio="16 / 9">
			<iframe
				v-if="channelName && channelName.length > 0"
				id="frame"
				:src="
          `https://player.twitch.tv/?channel=${channelName}&parent=caribbeanpick.tv&parent=localhost`
        "
				frameborder="0"
				scrolling="no"
				allowfullscreen="true"
			>
			</iframe>
		</v-responsive>
	</div>
</template>

<style scoped lang="scss">
#frame {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border: 0;
}
</style>
